module.exports = __webpack_public_path__ + "static/media/CT_2019_30447_W6053_pdf.522fd37b.pdf";